/**
 * Product
 */

import enhancedDeliveryEstimate from "../lib/enhanced-delivery-estimate";
import giftCardActions from "../lib/gift-card-actions";
import productBopis from "../lib/product-bopis";
import ProductConfigurables from "../lib/product-configurables";
import productFramingOptionsDropdown from "../lib/product-framing-options-dropdown";
import productGallery from "../lib/product-gallery";
import productGalleryCarousel from "../lib/product-gallery-carousel";
import productGalleryZoomModal from "../lib/product-gallery-zoom-modal";
import productShare from "../lib/product-share";
import productStoreSelectorApp from "../lib/product-store-selector-app";


const $productForm = document.getElementById("addToBagForm");
const $productSection = document.getElementById("product");
const productConfigurables = new ProductConfigurables({
  productForm: $productForm,
  productSection: $productSection
});
const $productAccordions = [...document.querySelectorAll(".js-pv-acc")];
const { init: initGalleryCarousel } = productGalleryCarousel() || null;

// Product form
productConfigurables.init();

// Gallery
productGallery();

// Gallery Carousel
if (initGalleryCarousel) {initGalleryCarousel();}

// Gallery Zoom Modal
productGalleryZoomModal();

// Product Share
productShare();

// Product Framing Options Dropdown
productFramingOptionsDropdown();

// Enhanced Delivery Estimate
enhancedDeliveryEstimate();

// Product Store Selector
productStoreSelectorApp();


// Gift Card Actions
giftCardActions();

// Product Accordions
if ($productAccordions && $productAccordions.length) {
  $productAccordions.forEach(($productAccordion) => {
    const openOption = __.hasClass($productAccordion.parentElement, "is-active") ? 0 : null;
    const productAccordion = SDG.accordion({
      dom: {
        id: $productAccordion.id
      },
      open_option: openOption
    });
    productAccordion.init();
  });
}

// Product Bopis
productBopis();
